import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { StorageService } from './services/storage.service';
import { mainStoreActions } from './stores/main-store/main-store.actions';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private store: Store,
    private storageService: StorageService,
  ) {
    this.getRememberedUser();
  }

  /**
   * get remembered user
   */
  private getRememberedUser() {
    const user = this.storageService.user;

    if (user) {
      UtilService.accessToken = user.accessToken;
      this.store.dispatch(mainStoreActions.setUser({user}));
    }
  }
}
